import { provinceAndCityData, regionData, CodeToText, TextToCode } from 'element-china-area-data'
import Vue from 'vue'
regionData.forEach(item => {
    if (item.value == 540000) {
        item.children.forEach(item1 => {
            if (item1.value == 540100) {
                item1.children.push({
                    label: "柳梧新区",
                    value: 540175
                })
            }
        })
    }
    if (item.value == 220000) {
        item.children.forEach(item1 => {
            if (item1.value == 220100) {
                item1.children.push({
                    label: "公主岭市",
                    value: 220184
                })
            }
        })
    }
})
Vue.set(CodeToText, 540175, '柳梧新区')
Vue.set(CodeToText, 220184, '公主岭市')
